export const PROCESSO_DISCIPLINAR_LIST = 'PROCESSO_DISCIPLINAR_LIST';
export const PROCESSO_DISCIPLINAR_LIST_START =
  'PROCESSO_DISCIPLINAR_LIST_START';
export const PROCESSO_DISCIPLINAR_LIST_SUCCESS =
  'PROCESSO_DISCIPLINAR_LIST_SUCCESS';
export const PROCESSO_DISCIPLINAR_LIST_ERROR =
  'PROCESSO_DISCIPLINAR_LIST_ERROR';
